<template>
  <div class="old-globals">
    <form @submit.prevent>
      <md-card class="gray-1 bg">
        <md-progress-bar v-if="loading" md-mode="query" />
        <md-card-header>
          <div class="md-layout md-alignment-center-center header-content">
            <img class="logo" alt="VRpatients Logo" src="../../../assets/images/VRP_Logo.png">
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="error" class="form-error">{{ error.message }}</div>
          <md-field>
            <md-input v-model.trim="email" placeholder="Email" />
          </md-field>
          <md-field>
            <md-input v-model="password" type="password" placeholder="Password" />
          </md-field>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <router-link to="signup">Create an account</router-link>
          <router-link to="reset-password">Forgot password</router-link>
          <md-button type="submit" class="md-raised md-primary" @click="login">Login</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
export default {
  name: 'login-form',
  props: {
    loading: { type: Boolean, default: false },
    error: { type: Object, default: null }
  },
  data: () => ({
    email: '',
    password: ''
  }),
  methods: {
    login() {
      this.$emit('login', this.email, this.password);
      this.$analytics.event('Login', 'login', this.email);
    }
  }
};
</script>

<style scoped>
.header-content {
  flex-direction: column;
}
.logo {
  max-width: 100px;
}
.form-error {
  white-space: normal;
  overflow-wrap: break-word;
}
</style>
